export default __webpack_public_path__ + "748c078.png";